import VideoLoader from "./lib/VideoLoader";
import debounceTime from "../utils/debounce-time";

const container = $('#landing-page-video');
const video = container.children('video').first();

// Only execute if we found a video element:
if (video.length > 0) {

    function getVideoSize() {
        return Math.max(container.width(), container.height());
    }

    function setVideoSize() {
        const size = getVideoSize() + 'px';
        video.attr('width', size);
        video.attr('height', size);
    }

    setVideoSize();
    window.addEventListener('resize', debounceTime(300, setVideoSize));

// https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
    const videoElement = video[0];
    const isCompleted = videoElement.complete || videoElement.readyState >= 2;

    if (!isCompleted) {
        const loader = new VideoLoader();

        video.on('loadeddata', () => {
            loader.loading = false;
            loader.$destroy();
            $(loader.$el).remove();
        });

        loader.$mount();
        container.append(loader.$el);
    }
}
